<template>
  <div class="default-layout">
    <toolbar/>
    <category-bar/>
    <div class="default-layout__inner">
      <slot/>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import CategoryBar from '@/components/navigation/CategoryBar.vue'
import FooterBar from '@/components/navigation/FooterBar.vue'
import Toolbar from '@/components/navigation/Toolbar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    CategoryBar,
    FooterBar,
    Toolbar,
  },
}
</script>

<style lang="scss" scoped>
.default-layout__inner {
  // toolbar, category bar, footer
  min-height: calc(100vh - 40px - 40px - 300px);
}
</style>
